export default () => ({
  items: [],
  pagination: [],
  item: {},
  projectsItems: [],
  companies: [],
  statistics: {},
  platforms: []
})
